import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AnalyticsManager from '../../services/AnalyticsManager'

export const usePageTracking = () => {
  const location = useLocation()
  const { pathname, search } = location
  useEffect(() => {
    AnalyticsManager.trackTypedEvent({
      event: 'Page View - Portal',
      path: pathname,
      search,
    })
  }, [pathname, search])
}
